import { AdminApiRoutes } from '@gr/core/admin-api-routes';
import type { OnlineUsersDto, PlatformBlogsDto, PlatformOverviewDto, StorageUsageDto } from '@gr/core/platform/admin/dto';
import type { OperationResult } from '@gr/utils/operation-result';
import type { HttpClient } from '../../../shared/http/http-client';

export class AdminApi {
  constructor(private readonly http: HttpClient) {}

  // ADM-UC-1
  overview(): Promise<OperationResult<PlatformOverviewDto>> {
    return this.http.get(AdminApiRoutes.platform.overview);
  }
  // ADM-UC-1, ADM-UC-1.CC-1
  storageUsage(): Promise<OperationResult<StorageUsageDto | null>> {
    return this.http.get(AdminApiRoutes.platform.storageUsage);
  }
  // ADM-UC-2
  blogs(): Promise<OperationResult<PlatformBlogsDto>> {
    return this.http.get(AdminApiRoutes.platform.blogs);
  }
  // ADM-UC-3
  online(): Promise<OperationResult<OnlineUsersDto>> {
    return this.http.get(AdminApiRoutes.platform.online);
  }
}
